import { render, staticRenderFns } from "./GoodsTable.vue?vue&type=template&id=707594a3&scoped=true&"
import script from "./GoodsTable.vue?vue&type=script&lang=js&"
export * from "./GoodsTable.vue?vue&type=script&lang=js&"
import style0 from "./GoodsTable.vue?vue&type=style&index=0&id=707594a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707594a3",
  null
  
)

export default component.exports